import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../../lib/auth";

export function RequireAuth({ children }: { children: React.ReactNode }) {
  const { me, loading } = useAuth();
  const loc = useLocation();
  if (loading) return <div className="p-6 text-slate-500">…</div>;
  if (!me) return <Navigate to={`/login?next=${encodeURIComponent(loc.pathname)}`} replace />;
  return <>{children}</>;
}

export function RequireAdmin({ children }: { children: React.ReactNode }) {
  const { me, loading } = useAuth();
  if (loading) return <div className="p-6 text-slate-500">…</div>;
  if (!me) return <Navigate to="/login" replace />;
  if (me.role !== "ADMIN") return <Navigate to="/app" replace />;
  return <>{children}</>;
}
